import {useEffect,useState} from "react";
import api,{formatApiErrorDetail} from "@/lib/api";
const classes="mt-1 w-full rounded-lg border bg-white px-3 py-2 text-sm";
const today=new Date().toISOString().slice(0,10);
const previous=new Date(Date.now()-6*86400000).toISOString().slice(0,10);
const money=c=>c==null?"Not established":new Intl.NumberFormat("en-US",{style:"currency",currency:"USD"}).format(c/100);

export default function MetaInsightsPanel({campaignId}){
 const [first,setFirst]=useState(previous),[last,setLast]=useState(today);
 const [data,setData]=useState(null),[busy,setBusy]=useState(false);
 const [error,setError]=useState(""),[notice,setNotice]=useState("");
 useEffect(()=>{setData(null);setError("");setNotice("");},[campaignId]);
 const sync=async()=>{
  if(!campaignId||busy||first>last)return;
  if(!window.confirm("Read Meta's reported campaign spend and impressions for this date range? This will not edit ads, make charges, or authorize a budget."))return;
  setBusy(true);setError("");setNotice("");
  try{
   const r=await api.post("/platform/marketing/meta-insights/"+campaignId+"/sync",
    {start_date:first,end_date:last});
   setData(r.data);
   setNotice("Meta provider-reported results reconciled. Manual expense receipts are kept separate.");
  }catch(e){
   setError(formatApiErrorDetail(e?.response?.data?.detail)||
    "Unable to retrieve verified Meta campaign spend. No estimated totals were substituted.");
  }finally{setBusy(false);}
 };
 return <section className="space-y-3 rounded-xl border bg-white p-4" data-testid="meta-provider-insights">
  <header>
   <h2 className="font-semibold">Meta provider spend vs. qualified leads</h2>
   <p className="mt-1 text-xs text-slate-600">Read-only acquisition reconciliation from the connected Meta campaign. No automatic advertising, no charges, and no double-counting of manually verified expenses.</p>
  </header>
  <div className="flex flex-wrap items-end gap-3">
   <label className="text-sm">Start date (inclusive)
    <input className={classes} type="date" value={first} max={today} onChange={e=>setFirst(e.target.value)}/>
   </label>
   <label className="text-sm">End date (inclusive)
    <input className={classes} type="date" value={last} max={today} onChange={e=>setLast(e.target.value)}/>
   </label>
   <button type="button" disabled={busy||!campaignId||!first||!last||first>last}
    className="rounded-lg border px-4 py-2 text-sm font-semibold disabled:opacity-40"
    data-testid="meta-insights-sync" onClick={sync}>
    {busy?"Checking Meta…":"Sync provider results (read-only)"}
   </button>
  </div>
  {error&&<p className="text-sm text-red-700" role="alert">{error}</p>}
  {notice&&<p className="text-sm" role="status">{notice}</p>}
  {data&&<div className="space-y-3" data-testid="meta-insights-summary">
   <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
    {[
     ["Meta-reported spend",money(data.provider_spend_cents)],
     ["Meta inquiries",data.meta_inquiries],
     ["Qualified Meta leads",data.qualified_meta_leads],
     ["Cost per qualified lead",money(data.cost_per_qualified_meta_lead_cents)],
    ].map(([label,value])=><div key={label} className="rounded-lg border p-3">
     <p className="text-xs text-slate-600">{label}</p>
     <strong className="mt-1 block text-lg">{value}</strong>
    </div>)}
   </div>
   <p className="text-xs text-slate-600">
    {data.provider_impressions} impressions · {data.provider_clicks} clicks ·
    {data.provider_days_received} provider-reported days in selected period · Reporting timezone: {data.ad_account_reporting_timezone}.
   </p>
   <p className="text-xs text-amber-800">
    {data.coverage_note} This is not proof of complete lifetime ad spend or net profit.
    Lead counts use Meta's original submission timestamp, not the later import time.
   </p>
  </div>}
 </section>;
}
